import { render, staticRenderFns } from "./Tmall.vue?vue&type=template&id=176aec21&scoped=true"
import script from "./Tmall.vue?vue&type=script&lang=js"
export * from "./Tmall.vue?vue&type=script&lang=js"
import style0 from "./Tmall.vue?vue&type=style&index=0&id=176aec21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176aec21",
  null
  
)

export default component.exports